
(function() {
  // Configuration
  const config = {
    delay: 500,                  // Initial delay for setup
    forceSelectionOnChange: true // Force selection of first available option2 when option1 changes
  };
  
  // Wait for DOM to be fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setTimeout(initVariantPicker, config.delay));
  } else {
    setTimeout(initVariantPicker, config.delay);
  }
  
  // Global initialization flag
  let isInitialized = false;
  
  function initVariantPicker() {
    if (isInitialized) return;
    isInitialized = true;
    
    // Set up a global event listener for all radio input changes
    document.addEventListener('change', function(event) {
      // Check if the changed element is an option1 radio input in a variant picker
      if (event.target.matches('variant-picker input[type="radio"][data-option-position="1"]') && event.target.checked) {
        const variantPicker = event.target.closest('variant-picker');
        if (variantPicker) {
          enhanceVariantPicker(variantPicker, event.target.value, true);
        }
      }
    });
    
    // Listen for variant:change events
    document.addEventListener('variant:change', function() {
      document.querySelectorAll('variant-picker').forEach(variantPicker => {
        const selectedOption1 = variantPicker.querySelector('input[data-option-position="1"]:checked');
        if (selectedOption1) {
          enhanceVariantPicker(variantPicker, selectedOption1.value, false);
        }
      });
    });
    
    // Initial enhancement for all variant pickers
    document.querySelectorAll('variant-picker').forEach(variantPicker => {
      const selectedOption1 = variantPicker.querySelector('input[data-option-position="1"]:checked');
      if (selectedOption1) {
        enhanceVariantPicker(variantPicker, selectedOption1.value, false);
      }
    });
  }

  function enhanceVariantPicker(variantPicker, selectedOption1Value, isManuallyTriggered) {
    // Get product data
    let productData = null;
    try {
      // Try to get product data from the variant picker itself or document
      const productJsonScript = variantPicker.querySelector('script[data-product-json]') || 
                               document.querySelector('script[data-product-json]');
      
      if (productJsonScript) {
        productData = JSON.parse(productJsonScript.textContent);
      } else {
        return;
      }
    } catch (e) {
      return;
    }
    
    // Get fieldsets and inputs
    const fieldsets = variantPicker.querySelectorAll('fieldset.variant-picker__option');
    if (fieldsets.length < 2) return;
    
    const option1Fieldset = fieldsets[0];
    const option2Fieldset = fieldsets[1];
    
    const option1Inputs = option1Fieldset.querySelectorAll('input[type="radio"]');
    const option2Inputs = option2Fieldset.querySelectorAll('input[type="radio"]');
    
    // Direct DOM method to get text from radio input's label
    function getTextFromInput(input) {
      const label = input.closest('label');
      if (!label) return null;
      
      const span = label.querySelector('span');
      return span ? span.textContent.trim() : null;
    }
    
    // Build variant availability mapping
    const variantMap = {};
    
    productData.variants.forEach(variant => {
      if (!variant.available) return;
      
      if (!variantMap[variant.option1]) {
        variantMap[variant.option1] = [];
      }
      
      if (variant.option2 && !variantMap[variant.option1].includes(variant.option2)) {
        variantMap[variant.option1].push(variant.option2);
      }
    });
    
    // Map each input to its option text
    const option1TextMap = {};
    const option2TextMap = {};
    
    // Map option1 inputs to their text values
    Array.from(option1Inputs).forEach((input, index) => {
      const text = getTextFromInput(input);
      if (text) {
        option1TextMap[input.value] = text;
      } else {
        // Try position-based mapping
        const uniqueOption1Values = [...new Set(productData.variants.map(v => v.option1))];
        if (index < uniqueOption1Values.length) {
          option1TextMap[input.value] = uniqueOption1Values[index];
        }
      }
    });
    
    // Map option2 inputs to their text values
    Array.from(option2Inputs).forEach((input, index) => {
      const text = getTextFromInput(input);
      if (text) {
        option2TextMap[input.value] = text;
      } else {
        // Try position-based mapping
        const uniqueOption2Values = [...new Set(productData.variants.map(v => v.option2))];
        if (index < uniqueOption2Values.length) {
          option2TextMap[input.value] = uniqueOption2Values[index];
        }
      }
    });
    
    // Reverse mapping for option2
    const option2ReverseMap = {};
    Object.entries(option2TextMap).forEach(([value, text]) => {
      option2ReverseMap[text] = value;
    });
    
    // Direct DOM methods for updating visibility
    function hideOption(input) {
      const label = input.closest('label');
      if (label) {
        label.style.display = 'none';
        input.disabled = true;
        label.classList.add('is-disabled');
      }
    }
    
    function showOption(input) {
      const label = input.closest('label');
      if (label) {
        label.style.display = '';
        input.disabled = false;
        label.classList.remove('is-disabled');
      }
    }
    
    // Get the form element associated with the variant picker
    const formId = variantPicker.getAttribute('form-id');
    const form = formId ? document.getElementById(formId) : null;
    
    // Function to find variant ID for a specific option combination
    function findVariantId(option1Text, option2Text) {
      const variant = productData.variants.find(v => 
        v.option1 === option1Text && 
        v.option2 === option2Text && 
        v.available === true
      );
      return variant ? variant.id : null;
    }
    
    // Function to directly select an option2 value
    function selectOption2(option2Value) {
      const option2Input = Array.from(option2Inputs).find(input => input.value === option2Value);
      if (!option2Input) return false;
      
      // Get option texts
      const option1Text = option1TextMap[selectedOption1Value];
      const option2Text = option2TextMap[option2Value];
      
      if (!option1Text || !option2Text) return false;
      
      // 1. Set checked state
      option2Input.checked = true;
      
      // 2. Update display span
      const displaySpan = option2Fieldset.querySelector('.variant-picker__option-info span');
      if (displaySpan) {
        displaySpan.textContent = option2Text;
      }
      
      // 3. Find variant ID for this combination
      const variantId = findVariantId(option1Text, option2Text);
      if (variantId && form) {
        // Update the form's variant ID
        const idField = form.querySelector('input[name="id"]');
        if (idField) {
          idField.value = variantId;
          idField.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
      
      // 4. Dispatch change event on the option2 input
      option2Input.dispatchEvent(new Event('change', { bubbles: true }));
      
      return true;
    }
    
    // Update option2 visibility and selection
    const option1Text = option1TextMap[selectedOption1Value];
    if (!option1Text) return;
    
    // Get available option2 values for this option1
    const availableOption2Values = variantMap[option1Text] || [];
    if (availableOption2Values.length === 0) return;
    
    // Update visibility of all option2 inputs
    Array.from(option2Inputs).forEach(input => {
      const option2Text = option2TextMap[input.value];
      if (!option2Text) return;
      
      const isAvailable = availableOption2Values.includes(option2Text);
      
      // Update visibility
      if (isAvailable) {
        showOption(input);
      } else {
        hideOption(input);
      }
    });
    
    // First available option2
    const firstAvailableOption2Text = availableOption2Values[0];
    const firstAvailableOption2Value = option2ReverseMap[firstAvailableOption2Text];
    
    if (!firstAvailableOption2Value) return;
    
    // Always force selection of first available option2 when option1 changes manually
    if (isManuallyTriggered && config.forceSelectionOnChange) {
      selectOption2(firstAvailableOption2Value);
    } else {
      // Check if current selection is valid
      const currentSelectedOption2 = Array.from(option2Inputs).find(input => input.checked);
      if (currentSelectedOption2) {
        const currentOption2Text = option2TextMap[currentSelectedOption2.value];
        const isCurrentSelectionValid = availableOption2Values.includes(currentOption2Text);
        
        // If current selection is not valid, select first available
        if (!isCurrentSelectionValid) {
          selectOption2(firstAvailableOption2Value);
        }
      } else {
        // No option is selected, select first available
        selectOption2(firstAvailableOption2Value);
      }
    }
  }
})();